module.exports = __webpack_public_path__ + "assets/comscore.f6714f55.svg";